import { DriveItem } from '@microsoft/microsoft-graph-types';
import { Company } from '../company.interface';

export enum DocumentCategory {
    FORM_LETTER = 'form-letter',
    THANK_YOU_LETTER = 'thank-you-letter',
}

export interface PrintDocument {
    /**
     * The unique identifier of this print document
     */
    _id: string;
    /**
     * The name of the print document
     */
    name: string;
    /**
     * The create log of the print document
     */
    createLog: string;
    /**
     * The update log of the print document
     */
    updateLog: string;
    /**
     * The file of the print document
     */
    file?: DriveItem;
    /**
     * The company of the print document
     */
    company: Company | string;

    /**
     * The category of the print document
     */
    category?: DocumentCategory;

    /**
     * The category name of the print document
     * @deprecated Use category enum instead
     */
    categoryName?: string;

    /**
     * The creation timestamp when this print document was created
     */
    createdAt: Date;
    /**
     * The timestamp when this print document was last updated
     */
    updatedAt: Date;
}
